import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNotify } from '@/components/snackbar';
import { FormScopes } from '../../../../utils/form';
import { sendAppTestEvents, TEST_EVENT_OUTCOME } from '../../../../services/apps';
import { validationSchema } from './validations';

export default function useAppSendTestEventModal({ appId, setScope, platform }) {
  const notify = useNotify();
  const [results, setResults] = useState([]);

  const form = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      events: [],
    },
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: sendAppTestEvents,
    onSuccess(eventResults) {
      if (eventResults.some(({ outcome }) => outcome === TEST_EVENT_OUTCOME.FAILED)) {
        setResults(eventResults);
        return;
      }

      notify.success(`Evento de teste de ${platform?.name} enviado com sucesso!`);
      setScope(FormScopes.INDEX);
      form.reset();
    },
    // O service devolve as falhas HTTP como resultado, então aqui só chega exceção fora do envio.
    // Sem este onError, o default global de mutations do Router assumiria a mensagem.
    onError() {
      notify.error(`Ocorreu um erro ao tentar enviar o evento de teste de ${platform?.name}`);
    },
  });

  function onSubmit(values) {
    setResults([]);
    mutate({ ...values, appId });
  }

  const clearResults = () => setResults([]);

  return {
    form,
    onSubmit: form.handleSubmit(onSubmit),
    isLoading,
    results,
    clearResults,
  };
}
